import React from 'react';

interface FileUploadProps {
  label?: string;
  isFileAttached: boolean;
  handleFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleFileAttach: () => Promise<void>;  // Change to async
  handleFileDelete: () => void;
  summary?: string;
}

export const FileUpload: React.FC<FileUploadProps> = ({
  label = "Attach document",
  isFileAttached,
  handleFileChange,
  handleFileAttach,
  handleFileDelete,
  summary = "The document size should be under 5 MB.",
}) => {
  return (
    <div className="browse">
        <label>{label}</label>
        {isFileAttached ? (
          <div className="box">
            <div id="imageElement" className='attached' />
            <button type="button" onClick={handleFileDelete} className="ibutton bdelete" title="Delete attachment"></button>
          </div>
        ) : (
          <div className="box">
            <input type="file" onChange={handleFileChange} />
            <button type="button" onClick={handleFileAttach} className="tbutton" title="Upload selected">Attach</button>
            <span>{summary}</span>
          </div>
        )}
      </div>
  );
};
